import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldType } from '../../Common/Types/Field'
import Dropdown from '../../Common/Components/Dropdown'
import i18next from 'i18next'

const options = [
  { value: 'IN_PROGRESS', label: i18next.t('sc:status.InProgress') },
  { value: 'COMPLETED', label: i18next.t('sc:status.Completed') },
  { value: 'FAILED', label: i18next.t('sc:status.Failed') },
]

const SwDeltaStatusDropdown = ({ value, onChange, required, error, helperText, ...other }) => {
  const { t } = useTranslation()

  return (
    <Dropdown
      label={t('common:fields.status')}
      required={required}
      value={value}
      onChange={onChange}
      options={options}
      error={error}
      helperText={helperText}
      {...other}
    />
  )
}

SwDeltaStatusDropdown.defaultProps = {
  required: false,
}

SwDeltaStatusDropdown.propTypes = FieldType

export default SwDeltaStatusDropdown
